const covers = document.querySelectorAll('.services-tiles_container_tile-cover');
const tiles = document.querySelectorAll('.services-tiles_container_tile');
let isPressed;

const handleIn = (h, index) => {
  // Calculate the starting and ending indices for the tiles in the same row
  const startIndex = Math.floor(index / 3) * 3;
  const endIndex = startIndex + 3;

  for (let i = startIndex; i < endIndex; i++) {
    tiles[i].style.height = `${h}px`;
  }
};

const ariaHidden = (tileCover, bool) => {
  tileCover.setAttribute('aria-hidden', `${bool}`);
};

window.onload = function () {
  for (const tile of tiles) {
    tile.style.height = `${tile.offsetHeight}px`;
    tile.style.transition = 'height 0.2s ease-in-out';
    tile.dataset.originalHeight = tile.offsetHeight;

    const tileCovers = tile.querySelector('.services-tiles_container_tile-cover');

    // get original covers height as they are before being stretched
    const tileCoversHeight = tileCovers.offsetHeight;

    // get the indices of the array to pick siblings of the same row in handleIn()
    const index = Array.from(tiles).indexOf(tile);

    tile.addEventListener('touchstart', () => {
      const isOpen = tile.getAttribute('is-open') === 'true';
      if (isOpen) {
        tileCovers.style.transform = 'translateY(100%)';
        tileCovers.style.transition = 'transform 0.2s ease-in';
        tile.removeAttribute('is-open');
        ariaHidden(tileCovers, true);

        for (const t of tiles) {
          t.style.height = '370px';
          tileCovers.style.transition = 'transform 0.2s ease-in';
        }
      } else if (tileCoversHeight > 370 && !isOpen) {
        handleIn(tileCovers.offsetHeight, index);
        tileCovers.style.transform = 'translateY(0)';
        tileCovers.style.transition = 'transform 0.2s ease-out';
        tile.setAttribute('is-open', 'true');
        ariaHidden(tileCovers, false);
      } else if (!isOpen) {
        tileCovers.style.transform = 'translateY(0)';
        tileCovers.style.transition = 'transform 0.2s ease-out';
        tile.setAttribute('is-open', 'true');
        ariaHidden(tileCovers, false);
      }
    });

    tile.addEventListener('mouseenter', () => {
      ariaHidden(tileCovers, false);

      if (tileCoversHeight > 370) {
        handleIn(tileCovers.offsetHeight, index);
      }
    });

    tile.addEventListener('mouseleave', () => {
      // back to original height
      for (const t of tiles) {
        ariaHidden(tileCovers, true);
        tileCovers.style.transition = 'transform 0.2s ease-in';
        t.style.height = '370px';
      }
    });

    tile.addEventListener('keydown', (e) => {
      const isKeydownPressed = e.key === 'Enter' || e.keyCode === 13;

      if (!isPressed && isKeydownPressed) {
        tileCovers.setAttribute('tabindex', '0');
        tileCovers.style.transform = 'translateY(0)';
        tileCovers.style.transition = 'transform 0.2s ease-in-out';
        isPressed = true;
        ariaHidden(tileCovers, false);
      } else if (isPressed && isKeydownPressed) {
        tileCovers.removeAttribute('tabindex');
        tileCovers.style.transform = 'translateY(100%)';
        tileCovers.style.transition = 'transform 0.2s ease-in-out';
        isPressed = false;
        ariaHidden(tileCovers, true);
      }
    });
  }
};
